module.exports = __webpack_public_path__ + "static/img/home_panter_logo.3ae8614.png";


//////////////////
// WEBPACK FOOTER
// ./static/pc/indexPage/home_panter_logo.png
// module id = WtmX
// module chunks = 0